import { withOAuth } from 'aws-amplify-react';
import React, { Component } from 'react';
import { Auth } from "aws-amplify";

class BotonOAuth extends Component {

  setLocalStorage = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getLocalStorage = (key) => {
    const local = localStorage.getItem(key);
    return JSON.parse(local); 
  }

  loginFederate = (e) => {
    this.setLocalStorage('loginFederate' , "true");
    const customProvider =  process.env.REACT_APP_OAUTH_PROVIDER;
    Auth.federatedSignIn({ customProvider: customProvider })
  }

  render(){
    
    return (
      <div className="input-button">
      <button onClick={(e)=>this.loginFederate(e)} className='"btn-login btn-small w100 no-box-shadow"'>
        USUARIO RIMAC
      </button>
      </div>
    )
  }
}
export default withOAuth(BotonOAuth);